export default class ReportInputs {
    constructor(inputGroup) {
        this.hotline = inputGroup.querySelector('#hotline')
        this.reportType = inputGroup.querySelector('#report-type')
        this.reportInterval = inputGroup.querySelector('#report')
        this.dashboard = document.querySelector('#dashboard')

        // get intervals if inputs have values on page load
        if (this.hotline?.value !== '' && this.reportType?.value !== '') {
            this.getAvailableReportIntervals()
        }

        this.hotline?.addEventListener('change', e => {
            e.preventDefault()
            this.dashboard.classList.remove('show')
            this.getAvailableReportIntervals()
            if (this.reportType.value === '') {
                this.reportInterval.setAttribute('disabled', '')
            }
        })

        this.reportType?.addEventListener('change', e => {
            e.preventDefault()
            this.dashboard.classList.remove('show')
            this.getAvailableReportIntervals()
            if (e.target.value !== '') {
                this.reportInterval.removeAttribute('disabled')
            } else {
                this.reportInterval.setAttribute('disabled', '')
            }
        })
        
        this.reportInterval?.addEventListener('change', e => {
            e.preventDefault()
            if (e.target.value !== '') {
                this.dashboard.classList.add('show')
            } else {
                this.dashboard.classList.remove('show')
            }
        })
    }

    clearSelectOptions(selectElement, keepEmptyOption=true) {
        for (let i = 0; i < selectElement.options.length; i++) {
            let option = selectElement.options[i]
            if (!keepEmptyOption || (keepEmptyOption && option.value !== '')) {
                selectElement.options.remove(i)
                i--
            }
        }
    }

    addSelectOptions(selectElement, optionsCollection, optionClasses='') {
        optionsCollection.forEach(option => {
            let optionElement = document.createElement('option')
            optionElement.value = option
            optionElement.innerHTML = option
            // js will raise an error if it's an empty string :eye_roll:
            if (optionClasses) {
                optionElement.classList.add(optionClasses)
            }
            selectElement.appendChild(optionElement)
        })
    }

    getAvailableReportIntervals() {
        fetch(
            `/en/reports/get_intervals/?hotline=${this.hotline.value}&report_type=${this.reportType.value}`,
            {method: 'get'}
        ).then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw response
            }
        }).then(json_data => {
            this.clearSelectOptions(this.reportInterval)
            const intervals = json_data['available_report_intervals']
            this.addSelectOptions(this.reportInterval, intervals)
        }).catch(error => {
            // just log for now
            console.error(error)
        })
    }

}
